<template>
  <div id="app">
    <img alt="Vue logo" src="./assets/logo.png">
    <h1>DSP Time Tracker</h1>
<navbar v-if="this.$store.getters.user.loggedIn == true"></navbar>
    <router-view></router-view>
  </div>
</template>

<script>

import '../vendor/bootstrap/css/bootstrap.min.css'
import '../fonts/Linearicons-Free-v1.0.0/icon-font.min.css'
import '../vendor/bootstrap/css/bootstrap.min.css'
import '../vendor/jquery/jquery-3.2.1.min.js'

export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
